import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 4a4 4 0 0 1 4-4h26a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#172B85",
  "fill-rule": "evenodd",
  d: "M10.75 15.858H8.69L7.147 9.792c-.073-.279-.229-.525-.458-.642A6.6 6.6 0 0 0 4.8 8.51v-.234h3.318c.458 0 .802.35.859.758l.801 4.376 2.059-5.134h2.002zm4.234 0H13.04l1.602-7.583h1.945zm4.119-5.482c.057-.409.4-.642.801-.642a3.54 3.54 0 0 1 1.888.35l.344-1.633a4.8 4.8 0 0 0-1.774-.35c-1.888 0-3.262 1.05-3.262 2.507 0 1.11.973 1.692 1.66 2.042.743.35 1.03.584.972.934 0 .524-.572.758-1.143.758a4.8 4.8 0 0 1-2.003-.467l-.343 1.634c.687.29 1.43.408 2.117.408 2.117.058 3.432-.992 3.432-2.567 0-1.983-2.69-2.1-2.69-2.974m9.497 5.482-1.545-7.583h-1.658a.86.86 0 0 0-.802.583l-2.86 7h2.002l.4-1.108h2.46l.23 1.108zm-2.917-5.54.571 2.857h-1.602z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#E8E8ED",
  d: "M4 1h26v-2H4zm29 3v16h2V4zm-3 19H4v2h26zM1 20V4h-2v16zm3 3a3 3 0 0 1-3-3h-2a5 5 0 0 0 5 5zm29-3a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zM30 1a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zM4-1a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }